import { Link } from "react-router-dom"
import React from "react"

function Footer() {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	return (
		<footer className="relative items-center  bg-white  lg:z-[300]">
			<div className="flex flex-col items-center justify-center bg-greenBG  py-4 font-Noto text-[16px] lg:mt-0 lg:flex-row lg:text-[20px]">
				<Link to={"/faq"} className="mb-2 text-white lg:mr-12" onClick={() => track("FAQ")}>
					FAQS
				</Link>
				<Link to={"/teilnahmebedingungen"} className="mb-2 text-white lg:mr-12" onClick={() => track("Teilnahmebedingungen")}>
					Teilnahmebedingungen
				</Link>
				{/* <Link to={"/kontakt"} className="mb-2 text-white lg:mr-12" onClick={() => track("Kontakt")}>
					Kontakt
				</Link> */}
				{/* <Link to={"/kontakt"} className="mb-2 text-white lg:mr-12" onClick={() => track("Datenschutz")}>
					Datenschutzbestimmungen
				</Link> */}
				<Link to={"/kontakt"} className="mb-2 text-white lg:mr-12" onClick={() => track("Kontakt")}>
					Kontakt
				</Link>
				<Link to={"/impressum"} className="mb-2 text-white lg:mr-12" onClick={() => track("Impressum")}>
					Impressum
				</Link>
			</div>
		</footer>
	)
}

export default Footer
